import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'dateAndTime',
    pure: false,
    standalone: false
})
export class DateAndTimePipe implements PipeTransform {
    transform(value: any): string {
        return moment.utc(value).format('D MMM,yyyy - HH:mm');
    }
}
